import React from 'react';
 // Import du fichier CSS pour les animations

const LoadingPage = () => {
  return (
    <div className="loading-container">
      <div className="loading-circle"></div>
      <div className="loading-circle"></div>
      <div className="loading-circle"></div>
      <p>Chargement en cours...</p>
    </div>
  );
}

export default LoadingPage;
